<template>
  <v-dialog :value="isOpen" width="500" @input="$emit('closed')">
    <v-card>
      <v-card-title class="subheading font-weight-bold px-4">
        <span>Add Lesson</span>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('closed')">close</v-icon>
      </v-card-title>

      <v-divider></v-divider>
      <v-form ref="form" @submit.prevent="doAddLesson">
        <v-container class="px-4">
          <app-alert
            class="mb-3"
            type="error"
            :message="error"
            :outline="true"
            @dismissed="error = false"
          />
          <v-layout justify-space-between row wrap>
            <v-flex xs12>
              <v-textarea
                label="Describe the lesson below"
                v-model="lesson.description"
                :rules="[rules.isRequired]"
                @input="canSave = true"
                required
              ></v-textarea>
            </v-flex>
          </v-layout>

          <v-layout class="mt-4 mb-2">
            <v-btn depressed color="accent" type="submit" :disabled="isSaving || !canSave">
              Save
              <v-progress-circular
                class="ml-3"
                :indeterminate="true"
                :size="18"
                :width="2"
                v-if="isSaving"
              ></v-progress-circular>
            </v-btn>
            <v-btn depressed @click="$emit('closed')">Cancel</v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { setFormData } from '@/utils/http'

export default {
	name: 'AddLesson',
	props: ['isOpen', 'aid', 'agent'],
	data () {
		return {
			lesson: {
				description: '',
				aid_id: this.aid,
				agent_id: this.agent
			},
			canSave: false,
			isSaving: false,
			error: false,
      rules: {
        isRequired: value => this.$validator.isRequired(value, 'Please describe the lesson')
      }
		}
	},
	methods: {
		doAddLesson () {
      if (!this.$refs.form.validate()) return

      this.isSaving = true
      this.error = false

      const lesson = Object.assign({}, this.lesson)
			const params = setFormData(lesson)
      this.$http.post('challenge/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
						lesson._id = response.data
						lesson.created = Math.round((new Date()).getTime() / 1000)
						this.$emit('saved', lesson)
						this.$refs.form.reset()
						this.$emit('closed')
					}
          else {
						this.error = response.message
					}
				})
				.finally(() => {
					this.canSave = false
					this.isSaving = false
				})
		}
	}
}
</script>
